const StimulationSVG = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
      <circle
        cx="64"
        cy="64"
        r="30"
        fill="none"
        stroke="#063"
        strokeWidth="2"
      />
      <path
        d="M64 34v10M64 84v10M94 64h-10M44 64H34M84.8 43.2l-7.1 7.1M43.2 84.8l7.1-7.1M84.8 84.8l-7.1-7.1M43.2 43.2l7.1 7.1"
        fill="none"
        stroke="#063"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default StimulationSVG;
